import type { ThemeTokens } from './tokens';

export function surfaceGradient(theme: ThemeTokens, role = theme.surfaceRole): string {
  return theme.surfaceGradients[role];
}
